export const LANGUAGE_OPTIONS = [
    { label: 'Español', value: 'es' },
    { label: 'English', value: 'en' }
];

const DEFAULT_LANGUAGE = 'es';
const LANGUAGE_OVERRIDE_PREFIX = 'preferredLanguageOverride::';

const safeParse = (value) => {
    try {
        return JSON.parse(value || '{}');
    } catch (error) {
        return {};
    }
};

const getStoredLanguage = (key) => {
    const parsed = safeParse(localStorage.getItem(key));
    const preferredLanguage = parsed?.data?.adminUser?.preferredLanguage;
    return preferredLanguage === 'en' || preferredLanguage === 'es'
        ? preferredLanguage
        : null;
};

const getActiveSessionUserId = () => {
    const parsed = safeParse(localStorage.getItem('userDetails'));
    return parsed?.data?.adminUser?._id || null;
};

const getLanguageOverrideKey = (userId) => (userId ? `${LANGUAGE_OVERRIDE_PREFIX}${userId}` : null);

const getLanguageOverrideForUser = (userId) => {
    const key = getLanguageOverrideKey(userId);
    if (!key) return null;

    const value = localStorage.getItem(key);
    return value === 'en' || value === 'es' ? value : null;
};

export const getPreferredLanguage = () => {
    const activeUserId = getActiveSessionUserId();
    return getLanguageOverrideForUser(activeUserId) || DEFAULT_LANGUAGE;
};

export const updateStoredAdminUserFields = (updates = {}) => {
    const activeUserId = getActiveSessionUserId();

    ['userDetails', 'adminUser'].forEach((key) => {
        const parsed = safeParse(localStorage.getItem(key));
        if (!parsed?.data?.adminUser) return;

        const nextPayload = {
            ...parsed,
            data: {
                ...parsed.data,
                adminUser: {
                    ...parsed.data.adminUser,
                    ...updates
                }
            }
        };

        localStorage.setItem(key, JSON.stringify(nextPayload));
    });

    if (updates.preferredLanguage === 'en' || updates.preferredLanguage === 'es') {
        const overrideKey = getLanguageOverrideKey(activeUserId);
        if (overrideKey) {
            localStorage.setItem(overrideKey, updates.preferredLanguage);
        }
    }

    if (typeof window !== 'undefined') {
        window.dispatchEvent(
            new CustomEvent('preferred-language-changed', {
                detail: {
                    preferredLanguage: updates.preferredLanguage || getPreferredLanguage()
                }
            })
        );
    }
};

export const isSpanishLanguage = (value) => (value || DEFAULT_LANGUAGE) === 'es';
